import React, { useState, useEffect } from "react";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import {
  getStockCounting,
  getStockCountingItem,
} from "../../../../../services/inventory/itemsMovement";
import { Editor } from "primereact/editor";
import { Badge } from "react-bootstrap";
import Illustration from "../../../../../partials/content/Illustration";
import { formatDate } from "../../../../../utils/utils";
import StocksCountingForm from "./stocksCountingForm";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { CustomOutlinedDisabledTextField } from "../../../../../partials/content/Forms";
import ResponsiveEllipsis from "../../../../../partials/content/ResponsiveEllipsis";
import { TabView, TabPanel } from "primereact/tabview";
import { Accordion, AccordionTab } from "primereact/accordion";
import { DialogActions } from "@material-ui/core";
import { Card } from "react-bootstrap";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
function StocksCounting({
  warehouseID: warehouseIDprop = 0,
  outletID: outletIDprop = 0,
  match,
}) {
  const { reload } = useGlobalData();
  const [openStockCountingForm, setOpenStockCountingForm] = useState(false);
  const [openStockCountingItem, setOpenStockCountingItem] = useState(false);
  const [stocksCounting, setStocksCounting] = useState([]);
  let warehouseID = 0;
  let outletID = 0;
  if (warehouseIDprop > 0) {
    warehouseID = warehouseIDprop;
  } else {
    const { warehouseID: warehouseIDparam = 0 } = match.params;
    warehouseID = parseInt(warehouseIDparam);
  }
  if (outletIDprop > 0) {
    outletID = outletIDprop;
  } else {
    const { outletID: outletIDparam = 0 } = match.params;
    outletID = parseInt(outletIDparam);
  }

  const [activeIndex, setActiveIndex] = useState(0);
  const [stockCountingHeader, setStockCountingHeader] = useState({
    ID: 0,
    createdByName: "",
    countDate: "",
    countStatus: 0,
    countStatusDesc: "",
    note: "",
  });
  const [stockCountingItem, setStockCountingItem] = useState([]);

  async function getStockCountingData(warehouseID, outletID) {
    const response = await getStockCounting(warehouseID, outletID);
    const { data } = response.data;
    setStocksCounting(data.stocksCounting);
  }

  async function getStockCountingItemData(stockCountingID) {
    const response = await getStockCountingItem(stockCountingID);
    const { data } = response.data;
    setStockCountingItem(data.stockCountingItem);
  }

  useEffect(() => {
    getStockCountingData(warehouseID, outletID);
  }, [warehouseID, outletID, reload]);

  const stockCountingDetailColumn = [
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      {stocksCounting.length ? (
        <React.Fragment>
          <CustomDataTable
            data={stocksCounting}
            dataDetailColumns={stockCountingDetailColumn}
            onRefreshData={() => {
              getStockCountingData(warehouseID, outletID);
            }}
            buttons={[
              {
                name: "New Stock Opname",
                onClick: (e) => {
                  setOpenStockCountingForm(true);
                },
                icon: "fas fa-plus-circle",
                color: "primary",
              },
            ]}
            columns={[
              {
                header: "Stock Opname ID",
                field: "ID",
                body: (rowData) => (
                  <React.Fragment>
                    <span>
                      <span>{rowData.ID}</span>
                      {rowData.surplusStock === true ? (
                        <BootstrapTooltip title={rowData.surplusStockDesc}>
                          <span className="ml-2">
                            <i className="fas fa-plus-square kt-font-success"></i>
                          </span>
                        </BootstrapTooltip>
                      ) : null}
                      {rowData.deficitStock === true ? (
                        <BootstrapTooltip title={rowData.deficitStockDesc}>
                          <span className="ml-2">
                            <i className="fas fa-minus-square kt-font-danger"></i>
                          </span>
                        </BootstrapTooltip>
                      ) : null}
                    </span>
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Person Responsible",
                field: "createdByName",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Stock Opname Status",
                field: "countStatusDesc",
                body: (rowData) => {
                  if (rowData.countStatus === 1) {
                    return (
                      <Badge variant="danger">{rowData.countStatusDesc}</Badge>
                    );
                  } else if (rowData.countStatus === 2) {
                    return (
                      <Badge variant="warning">{rowData.countStatusDesc}</Badge>
                    );
                  } else if (rowData.countStatus === 3) {
                    return (
                      <Badge variant="success">{rowData.countStatusDesc}</Badge>
                    );
                  } else {
                    return (
                      <Badge variant="dark">{rowData.countStatusDesc}</Badge>
                    );
                  }
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Have Surplus Stock",
                field: "surplusStockDesc",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Have Deficit Stock",
                field: "deficitStockDesc",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Stock Opname Date & Time",
                field: "countDate",
                body: (rowData) => formatDate(rowData.countDate, true, false),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    <BootstrapTooltip title="Stock Opname Detail">
                      <button
                        type="button"
                        onClick={(event) => {
                          setStockCountingHeader(rowData);
                          getStockCountingItemData(rowData.ID);
                          setOpenStockCountingItem(true);
                        }}
                        className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-list-alt"></i>
                      </button>
                    </BootstrapTooltip>
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Inventory.png"
            description="Hooray! You're ready to have your first Stock Opname for this warehouse!"
            guidance="Hint: manage your stock opname to increase the inventory bookkeeping accuracy"
            descriptionLeftIcon="fas fa-info-circle kt-font-success"
            size="md"
          ></Illustration>
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-primary btn-md btn-pill btn-bold mx-1"
              onClick={() => {
                setOpenStockCountingForm(true);
              }}
            >
              <i className="fas fa-plus-circle"></i>
              New Stock Opname
            </button>
          </div>
        </React.Fragment>
      )}
      <DialogLayout
        open={openStockCountingForm}
        title="Stock Opname Form"
        onCloseDialog={() => {
          setOpenStockCountingForm(false);
        }}
        minHeight={true}
      >
        <StocksCountingForm
          warehouseID={warehouseID}
          outletID={outletID}
          onCloseDialog={() => {
            setOpenStockCountingForm(false);
          }}
          onConfirmSave={() => {
            getStockCountingData(warehouseID, outletID);
            setOpenStockCountingForm(false);
          }}
        />
      </DialogLayout>
      <DialogLayout
        open={openStockCountingItem}
        title="Stock Opname Detail"
        onCloseDialog={() => {
          setOpenStockCountingItem(false);
        }}
        minHeight={true}
      >
        <div className="tabview mb-3">
          <div className="card">
            <TabView renderActiveOnly={false} className="tabview" scrollable>
              <TabPanel header="Stock Opname Main" rightIcon="fas fa-th-large">
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Card>
                      <Card.Header>
                        <i className="fas fa-window-maximize"></i>
                        <span>
                          <strong>Stock Opname Header</strong>
                        </span>
                        <Badge
                          className="float-right ml-1"
                          variant={
                            stockCountingHeader.countStatus === 1
                              ? "danger"
                              : stockCountingHeader.countStatus === 2
                              ? "warning"
                              : stockCountingHeader.countStatus === 3
                              ? "success"
                              : null
                          }
                        >
                          {stockCountingHeader.countStatus !== 0
                            ? "Stock Opname " +
                              stockCountingHeader.countStatusDesc
                            : null}
                        </Badge>
                      </Card.Header>
                      <Card.Body>
                        <div className="row">
                          <div className="col-sm-6 col-md-6 col-lg-6">
                            <CustomOutlinedDisabledTextField
                              label="Person Responsible"
                              value={stockCountingHeader.createdByName}
                            />
                          </div>
                          <div className="col-sm-6 col-md-6 col-lg-6">
                            <CustomOutlinedDisabledTextField
                              label="Stock Opname Date"
                              value={formatDate(stockCountingHeader.countDate)}
                            />
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              </TabPanel>
              <TabPanel header={`Note`} rightIcon="fas fa-sticky-note">
                <Editor
                  style={{ height: "200px", width: "100%" }}
                  value={stockCountingHeader.note}
                  placeholder="Type your notes here..."
                  readOnly={true}
                  className="editor-grey"
                />
              </TabPanel>
            </TabView>
          </div>
        </div>
        <div className="accordion">
          <div className="card">
            <Accordion
              className="accordion"
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <AccordionTab
                header={
                  <React.Fragment>
                    <i className="fas fa-sitemap"></i>
                    <span>
                      <strong>Stock Opname Items</strong>
                    </span>
                  </React.Fragment>
                }
              >
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <CustomDataTable
                      data={stockCountingItem}
                      onRefreshData={() => {
                        getStockCountingItemData(stockCountingHeader.ID);
                      }}
                      columns={[
                        {
                          header: "Stock Opname Item ID",
                          field: "ID",
                          body: null,
                          sortable: false,
                          filter: false,
                        },
                        {
                          header: "Item Type",
                          field: "itemTypeName",
                          body: (rowData) => (
                            <React.Fragment>
                              <ResponsiveEllipsis
                                text={rowData.itemTypeName}
                                maxLine="1"
                              />
                            </React.Fragment>
                          ),
                          sortable: true,
                          filter: true,
                          hidden: true,
                        },
                        {
                          header: "Item Code",
                          field: "itemCode",
                          body: (rowData) => (
                            <React.Fragment>
                              {rowData.itemType > 0 ? (
                                <span>
                                  <BootstrapTooltip
                                    title={rowData.itemTypeName}
                                  >
                                    <span className="mr-2">
                                      <i
                                        className={
                                          rowData.itemType === 1
                                            ? "fas fa-boxes text-success"
                                            : rowData.itemType === 2
                                            ? "fas fa-tools text-primary"
                                            : rowData.itemType === 3
                                            ? "fas fa-building text-info"
                                            : rowData.itemType === 4
                                            ? "fas fa-boxes text-warning"
                                            : rowData.itemType === 5
                                            ? "fas fa-boxes text-danger"
                                            : null
                                        }
                                      ></i>
                                    </span>
                                  </BootstrapTooltip>
                                  <span>
                                    <ResponsiveEllipsis
                                      text={rowData.itemCode}
                                      maxLine="1"
                                      displayInline
                                    />
                                  </span>
                                </span>
                              ) : (
                                <React.Fragment>
                                  <ResponsiveEllipsis
                                    text={rowData.itemCode}
                                    maxLine="1"
                                  />
                                </React.Fragment>
                              )}
                            </React.Fragment>
                          ),
                          sortable: true,
                          filter: true,
                        },
                        {
                          header: "Item Name",
                          field: "itemName",
                          body: (rowData) => (
                            <React.Fragment>
                              <ResponsiveEllipsis
                                text={rowData.itemName}
                                maxLine="1"
                              />
                            </React.Fragment>
                          ),
                          sortable: false,
                          filter: false,
                        },
                        {
                          header: "Counted",
                          field: "countedDesc",
                          body: (rowData) => {
                            if (rowData.counted === false) {
                              return (
                                <Badge variant="danger">
                                  {rowData.countedDesc}
                                </Badge>
                              );
                            } else if (rowData.counted === true) {
                              return (
                                <Badge variant="success">
                                  {rowData.countedDesc}
                                </Badge>
                              );
                            } else {
                              return (
                                <Badge variant="dark">
                                  {rowData.countedDesc}
                                </Badge>
                              );
                            }
                          },
                          sortable: false,
                          filter: false,
                        },
                        {
                          header: "System Quantity",
                          field: "systemQty",
                          body: null,
                          sortable: false,
                          filter: false,
                        },
                        {
                          header: "Counted Quantity",
                          field: "countedQty",
                          body: null,
                          sortable: false,
                          filter: false,
                        },
                        {
                          header: "Different Quantity",
                          field: "diffQty",
                          body: (rowData) => (
                            <>
                              {rowData.diffQty > 0 ? (
                                <span className="text-success">{`+${rowData.diffQty}`}</span>
                              ) : rowData.diffQty < 0 ? (
                                <span className="text-danger">{`${rowData.diffQty}`}</span>
                              ) : (
                                rowData.diffQty
                              )}
                            </>
                          ),
                          sortable: false,
                          filter: false,
                        },
                        {
                          header: "Different Reason",
                          field: "moveReason",
                          body: null,
                          sortable: false,
                          filter: false,
                        },
                        {
                          header: "Unit",
                          field: "uomName",
                          body: null,
                          sortable: false,
                          filter: false,
                        },
                        {
                          header: "Batch ID",
                          field: "batchID",
                          body: null,
                          sortable: false,
                          filter: false,
                        },
                      ]}
                    />
                  </div>
                </div>
              </AccordionTab>
            </Accordion>
          </div>
        </div>
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenStockCountingItem(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default StocksCounting;
